var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "trigger",
      staticClass: "dropdown-wrapper",
      on: { click: _vm.handleTriggerClicked }
    },
    [
      _vm.selectedItem
        ? _vm._t("selectedItem", null, { selectedItem: _vm.selectedItem })
        : _vm._e(),
      _c(
        "MountingPortal",
        { attrs: { mountTo: "#dropdowns-target", append: "" } },
        [
          _vm.isOpen
            ? _c(
                "div",
                {
                  ref: "dropdown",
                  staticClass: "dropdown",
                  class: _vm.dropdownClass,
                  attrs: { "data-testid": "dropdown" }
                },
                [
                  _c(
                    "ul",
                    { staticClass: "list" },
                    _vm._l(_vm.items, function(item) {
                      return _c(
                        "li",
                        {
                          key: item[_vm.itemKey],
                          staticClass: "list-item",
                          on: {
                            click: function($event) {
                              return _vm.handleSelectItem(item)
                            }
                          }
                        },
                        [_vm._t("item", null, { item: item })],
                        2
                      )
                    }),
                    0
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }